import {BrowserUtil} from './browser';
import {DateUtil} from './date';
import {DeviceUtil} from './device';
import {PlatformUtil} from './platform';
import {RestUtil} from './rest';
import {TextUtil} from './text';
import {UserUtil} from './user';
import {FileUtil} from './file';
import {DomUtil} from './dom';
import {DialogUtil} from './dialog';

export const Utils = {
	browser: BrowserUtil,
	date: DateUtil,
	device: DeviceUtil,
	platform: PlatformUtil,
	rest: RestUtil,
	text: TextUtil,
	user: UserUtil,
	file: FileUtil,
	dom: DomUtil,
	dialog: DialogUtil
};